@if (patient) {
  <app-patient-form
    [patient]="patient"
    action="{{ 'view' | translate }}"
    [disabled]="true"
    [buttonActions]="buttonActions"
    (close)="closeForm($event)">
  </app-patient-form>
}